import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cronFriendly',
  standalone: true,
})
export class CronFriendlyPipe implements PipeTransform {
  transform(schedule: string): string {
    if (!schedule) return '';

    //TODO: Revisar cron pipes con Backend
    // Mapeo para diferentes formatos específicos
    const scheduleMap: { [key: string]: string } = {
      '*/30 * * * *': 'Cada 30 minutos',
      '*/5 * * * *': 'Cada 5 minutos',
      '0 0 * * *': 'Diariamente a medianoche',
      '0 8 * * *': 'Diariamente a las 8:00 AM',
      '0 12 * * 1-5': 'Lunes a Viernes a las 12:00 PM',
      '0 0 1 * *': 'El primer día de cada mes',
      '0 0 1 1 *': 'El 1 de enero',
      '0 0 * * 0': 'Todos los domingos',
      '0 6,18 * * *': 'Diariamente a las 6:00 AM y 6:00 PM',
      '* * * * *': 'Cada minuto',
    };

    // Si está en el mapeo, retornar el valor mapeado
    if (scheduleMap[schedule]) {
      return scheduleMap[schedule];
    }

    // Manejar formato "every X hours/days/minutes"
    const everyMatch = schedule.match(/^every\s+(\d+)\s+(hour|hours|day|days|minute|minutes)$/i);
    if (everyMatch) {
      const value = everyMatch[1];
      const unit = everyMatch[2].toLowerCase();

      if (unit === 'hour' || unit === 'hours') {
        return `Cada ${value} ${value === '1' ? 'hora' : 'horas'}`;
      } else if (unit === 'day' || unit === 'days') {
        return `Cada ${value} ${value === '1' ? 'día' : 'días'}`;
      } else if (unit === 'minute' || unit === 'minutes') {
        return `Cada ${value} ${value === '1' ? 'minuto' : 'minutos'}`;
      }
    }

    // Si es una expresión cron válida (formato: minuto hora día mes día-semana)
    // Ejemplo: "55 23 * * *" -> "Diariamente a las 23:55"
    const cronPattern = /^(\S+)\s+(\S+)\s+(\S+)\s+(\S+)\s+(\S+)$/;
    const cronMatch = schedule.match(cronPattern);

    if (cronMatch) {
      const [, minute, hour, dayOfMonth, month, dayOfWeek] = cronMatch;

      // Si todos los campos de día/mes/semana son "*", es diario
      if (dayOfMonth === '*' && month === '*' && dayOfWeek === '*') {
        // Si la hora y minuto son números específicos
        if (!isNaN(Number(hour)) && !isNaN(Number(minute))) {
          const hourNum = Number(hour);
          const minuteNum = Number(minute);
          const timeStr = `${hourNum.toString().padStart(2, '0')}:${minuteNum
            .toString()
            .padStart(2, '0')}`;
          return `Diariamente a las ${timeStr}`;
        }
      }

      // Si no se puede convertir a texto amigable, mostrar la expresión cron tal cual
      return schedule;
    }

    // Si no coincide con ningún patrón, retornar el valor original
    return schedule;
  }
}
